import firebaseApp from "../firebase";
import {
  getFirestore,
  where,
  orderBy,
  query,
  collection,
  getDocs,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);
/**
 * get shipping methods from firebase.
 */
export const getShippingMethods = async ({ destinations }) => {
  const q = query(
    collection(db, "shipping-methods"),
    where("to_country", "in", destinations),
    orderBy("essential", "asc")
  );
  const data = await getDocs(q);

  return data.docs.map((doc) => doc.data());
};
